module.exports = __webpack_public_path__ + "static/media/raw.4adb846f.jpg";